import { useParams } from 'react-router-dom';
import { Edit as ApplicationEdit } from './Applications/Edit';
import { Edit as ApplicationGroupsEdit } from './ApplicationGroups/Edit';
import { Edit as EditApplicationLink } from './ApplicationLinks/Edit';
import { Edit as EditChat } from './Chats/Edit';
import { Edit as EditChatGroup } from './ChatsGroups/Edit';
import { Edit as EditChatTemplate } from './ChatsTemplates/Edit';
// import { Edit as EditUserGroup } from './UserGroups/Edit';

export const AdminEdit = () => {
  const { resource } = useParams();

  switch (resource) {
    case 'applications':
      return <ApplicationEdit />;
    case 'application-groups':
      return <ApplicationGroupsEdit />;
    case 'application-links':
      return <EditApplicationLink />;
    case 'chats':
      return <EditChat />;
    case 'chat-groups':
      return <EditChatGroup />;
    case 'chat-templates':
      return <EditChatTemplate />;
    default:
      return <div>Resource not supported: {resource}</div>;
  }
};
